import { useEffect, useState } from 'react';
import API from '../api/axios';
import './Logs.css';

const Logs = () => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    API.get('/logs')
      .then(res => setLogs(res.data))
      .catch(console.error);
  }, []);

  return (
    <div className="logs-page">
      <h1>📋 Activity Logs</h1>
      <div className="logs-list">
        {logs.map(log => (
          <div key={log.id} className="log-item">
            <div className="log-header">
              <span className="log-action">{log.action}</span>
              <span className="log-time">{new Date(log.created_at).toLocaleString('tr-TR')}</span>
            </div>
            <div className="log-detail">
              <span>👤 {log.admin_username}</span>
              {log.details && <span>📝 {log.details}</span>}
            </div>
          </div>
        ))}
        {logs.length === 0 && <p style={{ color: 'rgba(255,255,255,0.5)' }}>Henüz log kaydı yok.</p>}
      </div>
    </div>
  );
};

export default Logs;